<template>
  <div>
    <v-dialog v-model="globalDialog" :max-width="maxWidth" persistent>
      <v-card>
        <v-card-title :style="getThemeStyle" class="text-h5 lighten-2">{{
          title
        }}</v-card-title>

        <v-card class="mt-6 mx-4">
          <slot></slot>
        </v-card>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <vButton
            icon="mdi-close"
            color="red"
            class="mb-4"
            label="Close"
            :small="true"
            @button-clicked="closeGlobalDialogSlot"
          ></vButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import vButton from "@/components/Legos/vButton.vue";

export default {
  components: { vButton },
  props: {
    title: {
      default: "Title",
    },
    dialog: {
      default: false,
    },
    maxWidth: {
      default: "550",
    },
  },
  mounted() {
    this.globalDialog = this.dialog;
  },
  watch: {
    dialog(newVal) {
      this.globalDialog = newVal;
    },
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getGlobalDialogSlot() {
      return this.$store.getters.getGlobalDialogSlot;
    },
  },
  data: () => ({
    globalDialog: false,
  }),
  methods: {
    closeGlobalDialogSlot() {
      this.$emit("close-dialog");
    },
  },
};
</script>

<style></style>
